import { createSlice } from '@reduxjs/toolkit';

const commoditiesSlice = createSlice({
  name: 'commodities',
  initialState: [],
  reducers: {
    setCommodities: (state, action) => action.payload,
    addCommodity: (state, action) => {
      state.push(action.payload);
    },
    clearCommodities: () => []
  }
});

export const { setCommodities, addCommodity, clearCommodities } = commoditiesSlice.actions;
export const selectCommodities = state => state.commodities;
export default commoditiesSlice.reducer;
